<template>
    <div>
        <default-layout
            class="layout"
            :lbl="lbl"
            :locale="locale"
            :isLogin="isLogin"
            :profile="profile"
            :campaign="campaign"
            v-if="isLoaded && !isEven"
        ></default-layout>
        <event-layout
            class="layout"
            :lbl="lbl"
            :locale="locale"
            :isLogin="isLogin"
            :profile="profile"
            :campaign="campaign"
            v-if="isLoaded && isEven"
        ></event-layout>
        <modal
            view="campaign"
            :busModal="busModal"
        ></modal>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import Account from "@/helper/AccountHelper.js";
import BzbsCampaign from "@/service/BzbsCampaign.js";
import Locale from "@/helper/locale/locale.js";

import Modal from "@/components/modal/Modal.vue";
import DefaultLayout from "@/components/campaign/layout/Default.vue";
import EventLayout from "@/components/campaign/layout/Event.vue";
import { CampaignConfigBuilder } from "@/service/config/CampaignConfigModel.js";

export default {
    name: "Campaign",
    components: {
        DefaultLayout,
        EventLayout,
        Modal
    },
    data: function() {
        return {
            isLogin: false,
            user: {},
            profile: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            isEven: false,
            campaignId: "",
            campaign: null,
            campaignConfig: null,
            busModal: new Vue(),
        };
    },
    created: function() {
        this.initialIsFromLanding();
        this.initialCreate();
        //this.toggleBodyClass("addClass","keep-home");
    },
    activated() {
        // this.initialCreate();
        // this.toggleBodyClass("addClass","keep-home");
    },
    deactivated() {
        this.$destroy();
        this.toggleBodyClass("Remove","keep-home");
    },
    methods: {
        trackScreen: function () {
            var gtm = Account.getTrackViewGTM(this.user);
            Vue.ga.screenName(this, "privilege_campaign", gtm);
        },
        initialIsFromLanding: function () {
            // debugger;
            var formLanding = Account.getCacheCustom('isfromlanding');

            if (formLanding != null) {
                Account.removeCacheCustom('isfromlanding');

                var backAmount = (formLanding.page == 'interface') ? -2 : -1;
                history.go(backAmount);
            }
        },
        initialCreate: function() {
            this.showLoading();
            //Vue.ga.screenName(this, "privilege_campaign");
            Account.loginStatus().then(status => {
                this.isLogin = status;
                if (this.isLogin) {
                    this.user = Account.getCacheUser();
                    this.profile = Account.getCacheProfile();

                    this.trackScreen();
                    this.initialConfig();
                    this.getCampaign()

                } else {
                    if (this.$route.query && this.$route.query.lang && this.$route.query.lang == "EN") {
                        Locale.setLocale(1033);
                        this.lbl = Locale.getLbl();
                        this.locale = Locale.getLocaleCode()
                        this.initialConfig();
                        this.getCampaign();
                    } else {
                        Locale.setLocale(1054);
                        this.lbl = Locale.getLbl();
                        this.locale = Locale.getLocaleCode()
                        this.initialConfig();
                        this.getCampaign();
                    }
                }

            });
        },
        initialConfig: function() {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        getCampaign: function() {
            var strBzbsToken = Account.getToken();
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig)
                .then(result => {
                    this.campaign = result;

                    var label = this.campaign.id + "|" + this.campaign.name;
                    var gtm = {
                        "event_label": this.campaign.name,
                        "privilege_category_name": this.campaign.categoryName,
                        "privilege_id": this.campaign.id,
                        "timestamp": moment().format("YYYYMMDD HH:mm:ss")
                    };
                    Vue.ga.event(this, "privilege", "privilege_detail_impression", label, null, gtm);

                    if (Vue.CampaignType.Event == this.campaign.type) {
                        this.isEven = true;
                    }
                    this.isLoaded = true;
                    this.hideLoading();
                })
                .catch(error => {
                    console.log(error);
                });
        },
        switchLang: function(locale) {
            Locale.setLocale(locale);
            this.lbl = Locale.getLbl();
        },
        logout: function() {
            Account.setLogout();
            this.isLogin = false;
            this.profile = {};
        },
        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
            el.classList.add(className);
            } else {
            el.classList.remove(className);
            }
        },

        showLoading: function() {
            this.busModal.$emit("showLoadingModal");
        },

        hideLoading: function() {
            this.busModal.$emit("hideLoadingModal");
        },
    }
};
</script>
<style lang="scss">
@import "@/style/page/campaigndetail.scss";
</style>
